
import React, { Component, useRef } from 'react'
import './TimesheetMovement.css'
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';


export default class TimesheetToPodpis extends Component {
    constructor(props) {
        super(props)
        this.elHeight = document.getElementById('A4')
        var today = new Date(),
            date = today.getDate() + '.' + (today.getMonth().length < 8 ? '0' : '') + (today.getMonth() + 1) + '.' + today.getFullYear();
        this.state = {
            currentDate: date,
            heightA4: 0
        }
    }

    printDocument() {
        const input = document.getElementById('A4');
        html2canvas(input, {
            scale: 3,
        })
            .then((canvas) => {
                const name = "Timesheet.pdf"
                const imgData = canvas.toDataURL('image/png');
                const pdf = new jsPDF({
                    orientation: 'landscape',
                    dpi: 100,
                    format: 'A4'
                });;
                pdf.addImage(imgData, 'JPEG', 0, 0, 297, 210);
                // pdf.output('dataurlnewwindow');
                pdf.save(name);
            });
    }

    OpenSelectorOptions(options, option_name) {
        this.props.OpenSelectorOptions(options, option_name)
    }
    ApprovedRepor = (approved, id_timesheetMovement, timesheet_number) => {
        this.props.postApproveReport(approved, id_timesheetMovement, timesheet_number)
    }

    render() {
        const {
            DimDate,
            TimesheetPPS,
            Type_day,
            TimesheetMovement,
        } = this.props
        return (
            <div className="TimesheetMovement" >
                {TimesheetPPS && TimesheetPPS.length ?
                    <div ref={el => (this.componentRef = el)} id="A4" className='A4_to_podpis'  >
                        <h3 className='Title'>ТАБЕЛЬ  УЧЕТА РАБОЧЕГО ВРЕМЕНИ</h3>
                        <h4 className='under_Title'> {this.props.statuss === 0 ? 'Кафедра' : 'Отдел'} "{this.props.kafedra_otdel}" за  <span>{this.props.month?.toLowerCase()}</span> {this.props.years} г.</h4>
                        <div className='table_container'>
                            <table>
                                <thead>
                                    <tr>
                                        <th>№</th>
                                        <th>Ф.И.О.</th>
                                        <th>Должность</th>
                                        <th>База</th>
                                        <th><div className='rotate'>Ставка</div></th>
                                        {DimDate && DimDate.length && DimDate.map((item, index) => {
                                            return (
                                                <th key={'DimDate' + index}
                                                    style={{ padding: '0' }}
                                                    className={item.Day_off == 1 ? 'Weekend ' : null}>
                                                    {item.DayOfWeekName == 'понедельник' ? <p>Пн</p> : null}
                                                    {item.DayOfWeekName == 'вторник' ? <p>Вт</p> : null}
                                                    {item.DayOfWeekName == 'среда' ? <p>Ср</p> : null}
                                                    {item.DayOfWeekName == 'четверг' ? <p>Чт</p> : null}
                                                    {item.DayOfWeekName == 'пятница' ? <p>Пт</p> : null}
                                                    {item.DayOfWeekName == 'суббота' ? <p>Сб</p> : null}
                                                    {item.DayOfWeekName == 'воскресенье' ? <p>Вс</p> : null}
                                                    {item.DayDate}
                                                </th>
                                            )
                                        })}
                                        <th><div className='rotate'>Всего дней</div> </th>
                                        <th><div className='rotate'>Больнич. лист</div></th>
                                        <th><div className='rotate'>Командировка</div></th>
                                        <th><div className='rotate'>Трудовой отпуск</div></th>
                                        <th><div className='rotate'>Прогул</div></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {TimesheetPPS && TimesheetPPS.length ? TimesheetPPS.map((timesheet, timesheet_ind) => {
                                        return (
                                            <tr key={'timesheet' + timesheet_ind}>
                                                <td>{timesheet_ind + 1}</td>
                                                <td style={{ textAlign: 'left', minWidth: '100px' }}>{timesheet.s_t_fio}</td>
                                                <td>{timesheet.post}</td>
                                                <td>{timesheet.base_over.length > 5 ? timesheet.base_over.split('')[0] + timesheet.base_over.split('')[1] + timesheet.base_over.split('')[2] + timesheet.base_over.split('')[3] + timesheet.base_over.split('')[4] + timesheet.base_over.split('')[5] + '.' : timesheet.base_over}</td>
                                                <td>{timesheet.stavka}</td>
                                                {timesheet.arr.map((item, index) => {
                                                    return (
                                                        <td key={'DimDate' + index}
                                                            className={item.id_type_day == 1 ? 'Weekend ' : null}
                                                            style={{ padding: '0', fontWeight: item.id_type_day > 0 ? '600' : '400', width: '30px' }}
                                                        >
                                                            {item.yacheyka}
                                                        </td>
                                                    )

                                                })}
                                                <td style={{ fontWeight: 600 }}>
                                                    {timesheet.work}
                                                </td>
                                                <td>{timesheet.b > 0 ? timesheet.b : null}</td>
                                                <td>{timesheet.k > 0 ? timesheet.k : null}</td>
                                                <td>{timesheet.ot > 0 ? timesheet.ot : null}</td>
                                                <td>{timesheet.p > 0 ? timesheet.p : null}</td>
                                            </tr>
                                        )
                                    }) : null}
                                </tbody>
                            </table>
                        </div>
                        <div className='A4_Footer'>
                            {TimesheetMovement && TimesheetMovement.length ? TimesheetMovement.map((m, i) => {
                                return (
                                    <div key={'post' + { i }}>
                                        <p>{m.timesheet_post}:</p>
                                        <h4>{m.t_fio}</h4>

                                        {m.id_avn_login == this.props.id_AVN_User && m.approved == 0 ?
                                            <button title="Подтвердить" onClick={() => this.ApprovedRepor(true, m.id_timesheetMovement, m.timesheet_number)}>
                                                <i className="fas fa-pen-alt"></i> Подтвердить
                                            </button> :
                                            m.viewed > 0 && !m.approved ?
                                                <nav className='container'>
                                                    <i className="fas fa-check"></i>
                                                    Просмотрено
                                                </nav>
                                                :
                                                m.approved ?
                                                    <nav className='container'>
                                                        <i className="fas fa-check-double"></i>
                                                        Подтверждено
                                                    </nav>
                                                    : null}
                                    </div>
                                )
                            }) : null}
                        </div>
                    </div> : null}

            </div>
        )
    }
}


